import CardActions from './card-actions';

export default CardActions;